<template>
  <div class="border-2 border-gray-900">

    <LiabilityHeader 
      :index="index" 
      :updateValue="updateValue"
      :liabilityId="liability.id"
      :liabilityType="parseInt(liability.type)"
      :deleteLiability="deleteLiability"></LiabilityHeader>

    <div class="p-4">
      <div class="overflow-hidden">
        <div class="float-left pr-4" style="width:28%;">
          <InputText 
            label="Description"
            propertyKey="description"
            objectType="liability"
            :index="index"
            :objectId="objectId"
            :value="liability.description"
            :updateValue="updateValue"
            :required="true"></InputText>
        </div>

        <div class="float-left pr-2" style="width:22.5%;">
          <InputDollarValue 
            label="Monthly payment"
            propertyKey="monthly_payment"
            objectType="liability"
            :objectId="liability.id"
            :index="index"
            :value="liability.monthly_payment"
            :updateValue="updateValue"></InputDollarValue>
        </div>

        <div class="float-left pr-4" style="width:22.5%;">
          <InputDollarValue 
            label="Balance"
            propertyKey="balance"
            objectType="liability"
            tooltip="What amount do you currently owe?"
            :objectId="liability.id"
            :index="index"
            :value="liability.balance"
            :updateValue="updateValue"></InputDollarValue>
        </div>

        <div class="float-left" style="width:27%;">
          <Ownership :liability="liability" :objectIndex="index" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LiabilityHeader  from '../LiabilityHeader'
  import InputText        from '@/shared/components/form/InputText'
  import InputDollarValue from '@/shared/components/form/InputDollarValue'
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'
  import Ownership        from '@/shared/components/Ownership'

  export default {

    components: {
      LiabilityHeader,
      InputText,
      InputDollarValue,
      RequiredAsterisk,
      Ownership
    },

    props : {
      liability : {
        type : Object,
        required : true
      },

      index : {
        type : Number,
        required : false
      },

      objectId : {
        type    : Number,
        required: false
      },
      
      updateValue : {
        type     : Function,
        required : false
      },

      deleteLiability : {
        type    : Function,
        required: false
      },
    },

    methods : {

      // localUpdateValue steps in between the child component and the
      // parent component in order to inject an extra argument to the 
      // update value function since for liabilitys, we also need which
      // liability we are currently updating
      localUpdateValue(key, value) {
        this.updateValue({
          objectId: this.liability.id,
          index   :  this.index, 
          key     : key, 
          value   : value
        })
      }
    }
  }
</script>